import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import DeleteButton from "../common/DeleteButton";
import DecimalInput from "../common/DecimalInput";
import Cookies from "js-cookie";
import {getAuthHeader} from "../../utils/auth";
import {useNavigate} from "react-router-dom";
import {
    downloadSaleFile,
    findPaymentTermsByQueryString,
    findSectorsByQueryString
} from "../../utils/requestUtils";
import {searchCEP} from "../../core/Cep";
import {
    brazilianStates,
    formatDateToAmericanFormat, formatLocalDate,
    PaymentCondition,
    renderSaleOptions,
    SaleStatus,
    statusTranslate, UserPermission
} from "../../utils/utils";
import PaymentMethodValueSelect from "../paymentMehod/PaymentMethodValueSelect";
import DatePicker from "react-datepicker";
import Loading from "../../core/Loading";
import {formatCPF, validateCPF} from "../../core/cpf";
import {formatCNPJ, validateCNPJ} from "../../core/cnpj";
import {usePermission} from "../../core/PermissionContext";
import WhatsAppButton from '../../core/WhatsAppButton';
import { showConfirm, showAlert } from '../../core/dialog';

const apiUrl = Config.apiUrl;

const {v4: uuidv4} = require('uuid');

const SaleManager = () => {

    const { hasUserPermission, loadingPermissions } = usePermission();
    const DESCRIPTION_MAX_LENGTH = 1000;

    const [uuid, setUuid] = useState(uuidv4());
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const [originalTotalValue, setOriginalTotalValue] = useState(undefined);
    const [originalPaymentTerm, setOriginalPaymentTerm] = useState(undefined);
    const [originalPaidValue, setOriginalPaidValue] = useState(undefined);
    const [originalPaymentMethods, setOriginalPaymentMethods] = useState([]);
    const newEntity = {
        id: undefined,
        description: '',
        customerName: '',
        customerPhone: '',
        customerEmail: '',
        paymentMethods: [],
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        value: 0.0,
        paymentTerm: undefined,
        paidValue: 0.0,
        shippingCost: 0.0,
        totalValue: 0.0,
        status: 'OPENING',
        productionArea: undefined,
        deliveryType: undefined,
        details: '',
        saleDate: '',
        deliveryDate: undefined,
        sector: undefined,
        files: [],
        issueNfSeries1: false,
        cpfCnpjDelivery: '',
    };

    const [formData, setFormData] = useState(newEntity);
    const [totalValue, setTotalValue] = useState(Number(formData.value) + Number(formData.shippingCost));
    const [paymentTotalValue, setPaymentTotalValue] = useState(0);
    const [sectors, setSectors] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState([]);
    const [showPaymentMethodValueSelect, setShowPaymentMethodValueSelect] = useState(false);
    const [files, setFiles] = useState([]);
    const [filesToRemove, setFilesToRemove] = useState([]);

    const removeFile = async (index) => {
        if (!await showConfirm('Deseja realmente excluir o arquivo?')) {
            return;
        }
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFiles((prevFiles) => [...prevFiles, selectedFile]);
        }
    };

    const handleUpload = async (saleId, file) => {
        const formData = new FormData();
        formData.append('files', file);  // Altere 'file' para 'files'

        try {
            const response = await fetch(`${apiUrl}/api/sales/${saleId}/upload`, {
                method: 'POST',
                headers: {
                    ...getAuthHeader(),
                },
                body: formData,
            });

            if (response.ok) {
                console.log('Arquivo enviado com sucesso:', file.name);
            } else {
                console.error('Erro ao enviar arquivo:', file.name);
            }
        } catch (error) {
            console.error('Erro de rede ao enviar arquivo:', error);
        }
    };

    const handleRemoveFile = async (saleId, fileName) => {
        try {
            const response = await fetch(`${apiUrl}/api/sales/${saleId}/file/${fileName}`, {
                method: 'DELETE',
                headers: {
                    ...getAuthHeader(),
                }
            });

            if (response.ok) {
                console.log('Arquivo excluído com sucesso:', fileName);
            } else {
                console.error('Erro ao excluir arquivo:', fileName);
            }
        } catch (error) {
            console.error('Erro de rede ao excluir arquivo:', error);
        }
    };


    const handleUploadAll = async (saleId) => {
        for (const file of files) {
            await handleUpload(saleId, file);
        }
    };

    const handleRemoveAllFiles = async (saleId, files) => {
        for (const file of files) {
            await handleRemoveFile(saleId, file.displayFileName);
        }
    };

    useEffect(() => {
        let totalValue = 0.0;
        if (formData.deliveryType === 'DELIVERY') {
            totalValue += Number(formData.shippingCost);
        }
        totalValue += Number(formData.value);
        const paymentTotalValue = formData.paymentMethods.reduce((total, method) => {
            return total + Number(method.value);
        }, 0);

        setTotalValue(totalValue);
        setPaymentTotalValue(paymentTotalValue);
    }, [formData]);
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const [loading, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery() {
        if (id) {
            try {
                const url = apiUrl + '/api/sales/id=' + id;
                setLoading(true);
                const response = await makeRequest(url, 'GET');
                response.deliveryDate = new Date(response.deliveryDate);
                setOriginalTotalValue(response.totalValue);
                setOriginalPaymentTerm(response.paymentTerm);
                setOriginalPaidValue(response.paidValue);
                setFormData(response);
                setOriginalPaymentMethods(response.paymentMethods);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
        }
    }

    useEffect(() => {
        findSectorsByQueryString("").then(sectors => setSectors(sectors));
        findPaymentTermsByQueryString("").then(sectors => setPaymentTerms(sectors));
        makeQuery();
    }, [id]);

    function clearEntity() {
        setFormData(newEntity);
    }

    const onConfirm = async () => {
        try {
            if (validateInputs()) {
                if (totalValue > 0) {
                    openPaymentMethodValueSelect();
                } else {
                    confirmSale(undefined);
                }
            }
        } catch (error) {
            console.error('Error saving:', error);
            showAlert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    const confirmSale = async (paymentMethodValues) => {
        // setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 300));
        await saveEntity(paymentMethodValues);
        navigate('/app/salelist');
    }

    const isInstallmentWithDownPaymentSelected = formData?.paymentTerm?.paymentCondition === PaymentCondition.INSTALLMENT_WITH_DOWN_PAYMENT;


    function validateInputs() {
        if (!formData.customerName || formData.customerName === '') {
            showAlert('Preencha o campo Cliente.');
            return false;
        }

        if (!formData.customerPhone || formData.customerPhone === '') {
            showAlert('Preencha o campo Telefone.');
            return false;
        }

        if (!formData.deliveryDate) {
            showAlert('Preencha o campo Data de Entrega.');
            return false;
        }

        if (!formData.sector) {
            showAlert('Preencha o campo Setor.');
            return false;
        }


        if (!formData.value) {
            showAlert('Preencha o campo Valor.');
            return false;
        }

        if (!formData.productionArea) {
            showAlert('Preencha o campo Área de Produção.');
            return false;
        }

        if (!formData.deliveryType) {
            showAlert('Preencha o campo Tipo de Entrega.');
            return false;
        }

        if (formData.deliveryType === 'DELIVERY') {
            if (formData.cpfCnpjDelivery) {
                const cpfCnpjDeliveryOnlyNumbers = formData.cpfCnpjDelivery.trim().replace(/\D/g, '');

                let cpfCnpjValid = false;
                const length = cpfCnpjDeliveryOnlyNumbers.length;

                if (length === 11) {
                    cpfCnpjValid = validateCPF(cpfCnpjDeliveryOnlyNumbers);
                } else if (length === 14) {
                    cpfCnpjValid = validateCNPJ(cpfCnpjDeliveryOnlyNumbers);
                }

                if (!cpfCnpjValid) {
                    showAlert(length <= 11 ? 'CPF inválido para entrega.' : 'CNPJ inválido para entrega.');
                    return false;
                }
            }

            if (!formData.cep) {
                showAlert('Preencha o campo CEP.');
                return false;
            }

            if (!formData.address) {
                showAlert('Preencha o campo Endereço.');
                return false;
            }

            /* eslint-disable no-restricted-globals */
            if ((!formData.addressNumber || formData.addressNumber === 0) && !confirm('O Número do Endereço está zerado. Deseja realmente continuar?')) {
                return false;
            }

            if (!formData.neighborhood) {
                showAlert('Preencha o campo Bairro.');
                return false;
            }

            if (!formData.city) {
                showAlert('Preencha o campo Cidade.');
                return false;
            }

            if (!formData.state) {
                showAlert('Preencha o campo Estado.');
                return false;
            }
        }


        if (!formData.paymentTerm) {
            showAlert('Preencha o campo Condição de Pagamento.');
            return false;
        }

        if (!formData.paidValue && isInstallmentWithDownPaymentSelected) {
            showAlert('Preencha o campo Valor Pago.');
            return false;
        }

        if (!formData.paidValue && isInstallmentWithDownPaymentSelected) {
            showAlert('Preencha o campo Valor Pago.');
            return false;
        }

        if (formData.paidValue > totalValue) {
            showAlert('O Valor Pago não pode ser maior que o Valor Total.');
            return false;
        }

        if (!formData.description) {
            showAlert('Preencha o campo Descrição.');
            return false;
        }


        return true;
    }

    async function saveEntity(paymentMethodValues) {
        const url = apiUrl + '/api/sales';
        if (formData.deliveryType === 'LOCAL') {
            formData.address = '';
            formData.addressNumber = 0;
            formData.addressComplement = '';
            formData.neighborhood = '';
            formData.cep = '';
            formData.city = '';
            formData.state = '';
            formData.shippingCost = 0.0;
        }

        if (id) {
            await handleRemoveAllFiles(id, filesToRemove);
        }

        if(paymentMethodValues) {
            formData.paymentMethods = paymentMethodValues;
        } else {
            formData.paymentMethods = originalPaymentMethods;
        }

        setLoading(true);
        const response = await makeRequest(url, id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
            'requestuuid': uuid,
        }, JSON.stringify(formData));

        setLoading(false);
        if (response.id) {
            await handleUploadAll(response.id);
        }
    }

    function handleStateChange(idState) {
        setFormData((prevData) => ({
            ...prevData,
            state: idState,
        }));
    }

    function handleSectorSelected(value) {
        if (value) {
            const sector = sectors.find((p) => p.id === Number(value));
            setFormData((prevData) => ({
                ...prevData,
                sector: sector
            }));
        }
    }
    
    function handlePaymentTermSelected(value) {
        if (value) {
            const paymentTerm = paymentTerms.find((p) => p.id === Number(value));
            setFormData((prevData) => ({
                ...prevData,
                paymentTerm: paymentTerm,
                paidValue: paymentTerm.paymentCondition === PaymentCondition.FULL_PAYMENT ? prevData.value : 0
            }));
        }
    }

    function calculatePaymentMethods(paymentCondition, totalValue, paidValue, deliveryDate) {

        const paymentMethods = [];

        if (paymentCondition === PaymentCondition.FULL_PAYMENT ||
            paymentCondition === PaymentCondition.INSTALLMENT_WITH_DOWN_PAYMENT) {
            paymentMethods.push(
                {
                    paymentMethod: {id: undefined},
                    value: Number(paidValue),
                    baseValue: Number(paidValue),
                    dueDate: formatLocalDate(new Date()),
                    paid: true
                }
            );
        }

        if(totalValue > paidValue) {
            paymentMethods.push(
                {
                    paymentMethod: {id: undefined},
                    value: Number(totalValue) - Number(paidValue),
                    baseValue: Number(totalValue) - Number(paidValue),
                    dueDate: formatLocalDate(deliveryDate),
                    paid: false
                }
            );
        }


        return paymentMethods;

    }

    useEffect(() => {
        formData.paymentMethods = calculatePaymentMethods(formData?.paymentTerm?.paymentCondition, totalValue, formData.paidValue, formData.deliveryDate);
        setFormData(formData);
    }, [formData.paymentTerm, formData.paidValue, formData.deliveryDate, totalValue]);

    useEffect(() => {
        if (formData?.paymentTerm?.paymentCondition === PaymentCondition.FULL_PAYMENT) {
            setFormData(prevState => ({...prevState, paidValue: formData?.paymentTerm?.paymentCondition === PaymentCondition.FULL_PAYMENT ? totalValue : 0}));
        }
    }, [formData?.paymentTerm, totalValue]);
    function handleStatusSelected(value) {
        if (value) {
            setFormData((prevData) => ({
                ...prevData,
                status: value
            }));
        }
    }

    async function searchCepAndFillAddressInputs() {

        let result = undefined;
        // setLoading(true);
        try {
            result = await searchCEP(formData.cep);
        } finally {
            // setLoading(false);
        }
        if (result != null) {
            setFormData((prevData) => ({
                ...prevData,
                address: result.street,
                neighborhood: result.neighborhood,
                city: result.city,
                state: result.state,
            }));
        } else {
            showAlert('CEP não encontrado.');
        }
    }

    const openPaymentMethodValueSelect = () => {
        setShowPaymentMethodValueSelect(true);
    };

    const closePaymentMethodValueSelect = () => {
        setShowPaymentMethodValueSelect(false);
    };

    const handleDeliveryDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            deliveryDate: date
        }))
    };

    async function removeFileFromFormData(index) {
        if (!await showConfirm('Deseja realmente excluir o arquivo?')) {
            return;
        }
        setFilesToRemove((prevFiles) => [...prevFiles, formData.files[index]]);
        setFormData(prevFormData => ({
            ...prevFormData,
            files: prevFormData.files.filter((_, i) => i !== index)
        }));
    }

    function handleChangeCpfCnpjDelivery(e) {
        const {value} = e.target;

        let formattedValue = value;
        if (value.replace(/\D/g, "").length <= 11) {
            formattedValue = formatCPF(value);
        } else {
            formattedValue = formatCNPJ(value);
        }

        setFormData((prevData) => ({
            ...prevData,
            cpfCnpjDelivery: formattedValue
        }));
    }

    if (loadingPermissions) {
        return <Loading/>
    }

    if(hasUserPermission(UserPermission.CREATE_SERVICE) === false || (hasUserPermission(UserPermission.EDIT_SERVICE) === false && id)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <div className="app-form-page">
            {showPaymentMethodValueSelect && (
                <PaymentMethodValueSelect onItemClick={confirmSale} onClose={closePaymentMethodValueSelect}
                                          paymentMethods={id && totalValue === originalTotalValue && formData.paymentTerm?.id === originalPaymentTerm?.id ? originalPaymentMethods : formData.paymentMethods}
                                          futureDueDate={formData.deliveryDate}
                                          paymentTerm={formData.paymentTerm}
                                          totalValue={totalValue}
                                          allowChangeValue={false}
                                          allowChangeDueDate={false}
                                          onConfirm={(paymentMethodValues) => {
                                              closePaymentMethodValueSelect();
                                              confirmSale(paymentMethodValues);
                                          }}
                />)
            }

            <div
                className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Serviço {formData.id > 0 ? '-' : ''} {formData.code}</div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Cliente:</div>
                    <input type="text" style={{width: '300px'}} value={formData.customerName} name="customerName"
                           onChange={handleChange} data-test="customer-name-input"/>
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Telefone:</div>
                    <div className="phone-field-inline">
                        <input type="text" style={{width: '300px'}} value={formData.customerPhone} name="customerPhone"
                               onChange={handleChange} data-test="customer-phone-input"/>
                        <WhatsAppButton phoneNumber={formData.customerPhone} personName={formData.customerName}/>
                    </div>
                </div>
                {/*<div style={{marginTop: '5px', alignItems: 'center'}}>*/}
                {/*    <div>Email</div>*/}
                {/*    <input type="email" style={{width: '300px'}} value={formData.customerEmail} name="customerEmail"*/}
                {/*           onChange={handleChange}/>*/}
                {/*</div>*/}
            </div>
            <div style={{display: 'flex'}}>
                {formData.user &&
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div>Vendedor</div>
                        <input disabled={true} value={formData.user.name}/>
                    </div>
                }
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Status</div>
                    <select value={formData.status} onChange={(e) => handleStatusSelected(e.target.value)} data-test="service-status-select">
                        {renderSaleOptions()}
                    </select>
                </div>

                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Data de Entrega:</div>
                    <DatePicker
                        className="datepicker-time"
                        selected={formData.deliveryDate}
                        onChange={handleDeliveryDateChange}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={30}
                        dateFormat="dd/MM/yyyy HH:mm"
                        timeCaption="Hora"
                        autoComplete="off"
                        isClearable
                        data-test="delivery-date-picker"
                        name="deliveryDate"
                    />
                </div>

                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Setor</div>
                    <select value={formData?.sector?.id}
                            onChange={(e) => handleSectorSelected(e.target.value)} data-test="sector-select">
                        <option value="">Selecione o Setor</option>
                        {sectors.map((sector, index) => (
                            <option key={index} value={sector.id}>
                                {sector.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Valor:</div>
                    <DecimalInput
                        style={{width: '100px'}}
                        placeholder="0,00"
                        value={formData.value}
                        name="value"
                        onChange={handleChange}
                        data-test="service-value-input"/>
                </div>

                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{height: '17px'}}>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input type="checkbox"
                               checked={formData.issueNfSeries1}
                               name="issueNfSeries1"
                               onChange={handleChange}/>
                        <div>Emitir NF série 1?</div>

                    </div>
                </div>

            </div>


            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div>Área de Produção</div>
                <select value={formData?.productionArea}
                        onChange={(e) =>
                            setFormData((prevData) => ({
                                ...prevData,
                                productionArea: e.target.value
                            }))
                        } data-test="production-area-select">
                    <option value="">Selecione a Área de Produção</option>
                    <option key={'LOCAL'} value={'LOCAL'}>
                        {'Local'}
                    </option>
                    <option key={'PARTNER'} value={'PARTNER'}>
                        {'Parceiro'}
                    </option>

                </select>
            </div>

            <div style={{display: 'flex'}}>

                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Tipo de Entrega</div>
                    <select value={formData?.deliveryType}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                    ...prevData,
                                    deliveryType: e.target.value
                                }))
                            } data-test="delivery-type-select">
                        <option value="">Selecione o Tipo de Entrega</option>
                        <option key={'LOCAL'} value={'LOCAL'}>
                            {'Local'}
                        </option>
                        <option key={'DELIVERY'} value={'DELIVERY'}>
                            {'Delivery'}
                        </option>

                    </select>
                </div>
                {formData.deliveryType === 'DELIVERY' && (
                    <>
                        <div style={{marginTop: '5px', alignItems: 'center'}}>
                            <div>Frete:</div>
                            <DecimalInput
                                style={{width: '100px'}}
                                placeholder="0,00"
                                value={formData.shippingCost}
                                name="shippingCost"
                                onChange={handleChange}
                                data-test="shipping-cost-input"/>
                        </div>
                        <div style={{marginTop: '5px', alignItems: 'center'}}>
                            <div>CPF/CNPJ de Entrega:</div>
                            <input maxLength={18}
                                   value={formData.cpfCnpjDelivery}
                                   name="cpfCnpjDelivery"
                                   onChange={handleChangeCpfCnpjDelivery} data-test="cpf-cnpj-delivery-input"/>
                        </div>
                    </>
                )}
            </div>
            {formData.deliveryType === 'DELIVERY' && (
                <>
                    <div style={{display: 'flex'}}>
                        <div style={{marginTop: '5px', alignItems: 'center'}}>
                            <div style={{width: '80px'}}>CEP:</div>
                            <div className="cep-field-inline">
                                <input style={{width: '80px'}} type="text" id="cep" value={formData.cep} name="cep"
                                       onChange={handleChange} data-test="delivery-cep-input"/>
                                <button type="button" onClick={searchCepAndFillAddressInputs} data-test="search-cep-button">Buscar CEP</button>
                            </div>
                        </div>
                        <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                            <div style={{width: '180px'}}>Endereço:</div>
                            <input maxLength={255} type="text" style={{width: '297px'}} value={formData.address}
                                   name="address"
                                   onChange={handleChange} autoComplete={false} data-test="delivery-address-input"/>
                        </div>

                        <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                            <div style={{width: '70px'}}>Número:</div>
                            <input type="number" step="1" placeholder="0" style={{width: '70px'}}
                                   value={formData.addressNumber} name="addressNumber"
                                   onChange={handleChange} autoComplete={false} data-test="delivery-address-number-input"/>
                        </div>

                        <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                            <div style={{width: '180px'}}>Complemento:</div>
                            <input maxLength={100} type="text" style={{width: '310px'}}
                                   value={formData.addressComplement}
                                   name="addressComplement"
                                   onChange={handleChange} autoComplete={false} data-test="delivery-address-complement-input"/>
                        </div>

                    </div>
                    <div style={{display: 'flex'}}>

                        <div style={{marginTop: '5px', alignItems: 'center'}}>
                            <div style={{width: '180px'}}>Bairro:</div>
                            <input maxLength={100} type="text" style={{width: '400px'}} id="neighborhood"
                                   value={formData.neighborhood}
                                   name="neighborhood" onChange={handleChange} data-test="delivery-neighborhood-input"/>
                        </div>


                        <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                            <div style={{width: '180px'}}>Cidade:</div>
                            <input maxLength={100} type="text" style={{width: '290px'}} id="city" value={formData.city}
                                   name="city" onChange={handleChange} data-test="delivery-city-input"/>
                        </div>


                        <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                            <div style={{width: '180px'}}>Estado:</div>
                            <select value={formData.state} onChange={(e) => handleStateChange(e.target.value)} data-test="delivery-state-select" name={"deliveryType"}>
                                <option value="">Selecione...</option>
                                {brazilianStates.map((estado) => (
                                    <option key={estado.sigla} value={estado.sigla}>
                                        {estado.sigla} - {estado.nome}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </>
            )}

            <div style={{marginTop: '5px', alignItems: 'center', display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Condição de Pagamento</div>
                    <select value={formData?.paymentTerm?.id}
                            onChange={(e) => handlePaymentTermSelected(e.target.value)}
                            data-test={"payment-term-select"}>
                        <option value="">Selecione a Condição de Pagamento</option>
                        {paymentTerms.map((paymentTerm, index) => (
                            <option key={index} value={paymentTerm.id}>
                                {paymentTerm.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Valor Pago:</div>
                    <DecimalInput
                        data-test={"paid-value"}
                        disabled={!formData.paymentTerm || !isInstallmentWithDownPaymentSelected}
                        style={{width: '100px'}}
                        placeholder="0,00"
                        value={formData.paidValue}
                        name="paidValue"
                        onChange={handleChange}/>
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Valor Restante:</div>
                    <input data-test={"pending-value"} type="number" style={{width: '100px'}} placeholder="0.00" disabled={true}
                           value={totalValue - formData.paidValue >= 0 ? totalValue - formData.paidValue : 0}/>
                </div>

            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div>Descrição:</div>
                <textarea style={{width: '1000px', height: '100px'}} value={formData.description} name="description"
                          onChange={handleChange} data-test="service-description-input"/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div>Arquivos</div>
                <ul style={{display: 'flex', flexDirection: 'column', padding: 0}}>
                    {formData.files.map((file, index) => (
                        <li key={index}
                            style={{display: 'flex', alignItems: 'center', marginBottom: '8px', listStyle: 'none'}}>
                            <DeleteButton title="Remover" onClick={() => removeFileFromFormData(index)}/>
                            <a href="" style={{cursor: "pointer"}} onClick={(e) => {
                                e.preventDefault();
                                downloadSaleFile(formData.id, file.displayFileName);
                            }}>
                                {file.displayFileName}
                            </a>

                        </li>
                    ))}

                    {files.map((file, index) => (
                        <li key={index}
                            style={{display: 'flex', alignItems: 'center', marginBottom: '8px', listStyle: 'none'}}>
                            <DeleteButton title="Remover" onClick={() => removeFile(index)}/>
                            <a
                                href={URL.createObjectURL(file)}
                                download={file.name}
                            >
                                {file.name}
                            </a>
                        </li>
                    ))}
                </ul>
                <button onClick={() => document.getElementById('fileInput').click()}>
                    Adicionar Arquivo
                </button>
                <input
                    type="file"
                    id="fileInput"
                    onChange={handleFileChange}
                    style={{display: 'none'}} // Ocultar o input de arquivo
                />
            </div>

            <div className="total-label" style={{height: '37.6px', display: 'flex', alignItems: "center"}}>
                Valor Total: R$ {totalValue.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}
            </div>
            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    )
};

export default SaleManager;
